import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock, Fragment as _Fragment, unref as _unref, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/image/set-d2c.png'


const _withScopeId = n => (_pushScopeId("data-v-9ee11d6e"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "product-card" }
const _hoisted_2 = { class: "rel" }
const _hoisted_3 = { class: "img-wrapper" }
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: "https://static-s.theckb.com/BusinessMarket/Client/associated/error_img.png",
  alt: "",
  style: {"width":"100%"}
}, null, -1))
const _hoisted_5 = ["href"]
const _hoisted_6 = { class: "img-wrapper" }
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: "https://static-s.theckb.com/BusinessMarket/Client/associated/error_img.png",
  alt: "",
  style: {"width":"100%"}
}, null, -1))
const _hoisted_8 = {
  key: 1,
  class: "img-wrapper"
}
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: "https://static-s.theckb.com/BusinessMarket/Client/associated/error_img.png",
  alt: "",
  style: {"width":"100%"}
}, null, -1))
const _hoisted_10 = {
  key: 2,
  class: "img-wrapper"
}
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: "https://static-s.theckb.com/BusinessMarket/Client/associated/error_img.png",
  alt: "",
  style: {"width":"100%"}
}, null, -1))
const _hoisted_12 = { class: "info-item flex-center" }
const _hoisted_13 = { class: "info line--2" }
const _hoisted_14 = ["href"]
const _hoisted_15 = { class: "info-item flex-center" }
const _hoisted_16 = { class: "info line--2" }
const _hoisted_17 = {
  key: 1,
  class: "info-item flex-center"
}
const _hoisted_18 = { class: "oem-tag" }
const _hoisted_19 = { class: "info line--2" }
const _hoisted_20 = {
  key: 2,
  class: "info-item flex-center"
}
const _hoisted_21 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  referrerPolicy: "no-referrer",
  src: _imports_0,
  style: {"width":"24px","margin-right":"6px"},
  class: "order-tag"
}, null, -1))
const _hoisted_22 = { class: "info line--2" }
const _hoisted_23 = {
  key: 3,
  class: "info-item line--2"
}
const _hoisted_24 = ["src"]
const _hoisted_25 = { class: "info" }
const _hoisted_26 = { class: "price" }
const _hoisted_27 = {
  key: 4,
  style: {"margin-bottom":"8px"}
}

import { t } from '@/plugins/i18n'

import LogoIcon from '@/components/common/LogoIcon.vue'
import GoodsLink from '@/components/common/GoodsLink.vue'
import { calType } from '@/common/utils'
import BlackMask from '@/components/BlackGoods/BlackMask.vue'
import { apiShopIcon } from '@/common/const'
import { ElMessage } from 'element-plus'
import { showCurrentUnit } from '@/util/useYan'
import {COUNTRY} from '@/global'

export default /*#__PURE__*/_defineComponent({
  props: ['data'],
  emits: ['selectRow'],
  setup(__props, { emit }) {

const props = __props


const selectFn = () => {
  // if (props.data.blackTag === 1) {
  //   ElMessage.warning(t('黑名单商品不允许关联商品'))
  //   return
  // }
  // if (props.data.isOnline === 0) {
  //   ElMessage.warning(t('失效商品不允许关联商品'))
  //   return
  // }
  emit('selectRow', props.data)
}

return (_ctx: any,_cache: any) => {
  const _component_el_image = _resolveComponent("el-image")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      (__props.data.type === 'common')
        ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
            (__props.data.productCode)
              ? (_openBlock(), _createBlock(GoodsLink, {
                  key: 0,
                  goods: __props.data
                }, {
                  default: _withCtx(() => [
                    _createElementVNode("div", _hoisted_3, [
                      _createVNode(_component_el_image, {
                        referrerPolicy: "no-referrer",
                        lazy: "",
                        "data-goods": "",
                        src: __props.data.img,
                        class: "btn"
                      }, {
                        error: _withCtx(() => [
                          _hoisted_4
                        ]),
                        _: 1
                      }, 8, ["src"])
                    ]),
                    _createVNode(BlackMask, {
                      type: "goods",
                      item: __props.data
                    }, null, 8, ["item"])
                  ]),
                  _: 1
                }, 8, ["goods"]))
              : (_openBlock(), _createElementBlock("a", {
                  key: 1,
                  href: __props.data.productDetailUrl,
                  target: "_blank"
                }, [
                  _createElementVNode("div", _hoisted_6, [
                    _createVNode(_component_el_image, {
                      referrerPolicy: "no-referrer",
                      lazy: "",
                      "data-goods": "",
                      src: __props.data.img,
                      class: "btn"
                    }, {
                      error: _withCtx(() => [
                        _hoisted_7
                      ]),
                      _: 1
                    }, 8, ["src"])
                  ]),
                  _createVNode(BlackMask, {
                    type: "goods",
                    item: __props.data
                  }, null, 8, ["item"])
                ], 8, _hoisted_5))
          ], 64))
        : (__props.data.type === 'shopProduct')
          ? (_openBlock(), _createElementBlock("div", _hoisted_8, [
              _createVNode(_component_el_image, {
                referrerPolicy: "no-referrer",
                lazy: "",
                "data-goods": "",
                src: __props.data.img,
                class: "btn"
              }, {
                error: _withCtx(() => [
                  _hoisted_9
                ]),
                _: 1
              }, 8, ["src"])
            ]))
          : (_openBlock(), _createElementBlock("div", _hoisted_10, [
              _createVNode(_component_el_image, {
                referrerPolicy: "no-referrer",
                lazy: "",
                "data-goods": "",
                src: __props.data.img,
                class: "btn"
              }, {
                error: _withCtx(() => [
                  _hoisted_11
                ]),
                _: 1
              }, 8, ["src"])
            ]))
    ]),
    (__props.data.type === 'common')
      ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
          (__props.data.productCode)
            ? (_openBlock(), _createBlock(GoodsLink, {
                key: 0,
                goods: __props.data
              }, {
                default: _withCtx(() => [
                  _createElementVNode("div", _hoisted_12, [
                    _createElementVNode("p", _hoisted_13, [
                      _createVNode(LogoIcon, {
                        class: "mr_5",
                        type: _unref(calType)(__props.data),
                        style: {"float":"left"}
                      }, null, 8, ["type"]),
                      _createTextVNode(" " + _toDisplayString(__props.data.name), 1)
                    ])
                  ])
                ]),
                _: 1
              }, 8, ["goods"]))
            : (_openBlock(), _createElementBlock("a", {
                key: 1,
                href: __props.data.productDetailUrl,
                target: "_blank"
              }, [
                _createElementVNode("div", _hoisted_15, [
                  _createElementVNode("p", _hoisted_16, [
                    _createVNode(LogoIcon, {
                      class: "mr_5",
                      type: _unref(calType)(__props.data),
                      style: {"float":"left"}
                    }, null, 8, ["type"]),
                    _createTextVNode(" " + _toDisplayString(__props.data.name), 1)
                  ])
                ])
              ], 8, _hoisted_14))
        ], 64))
      : (__props.data.type === 'oem')
        ? (_openBlock(), _createElementBlock("div", _hoisted_17, [
            _createElementVNode("div", _hoisted_18, _toDisplayString(_unref(t)('OEM')), 1),
            _createElementVNode("p", _hoisted_19, _toDisplayString(__props.data.name), 1)
          ]))
        : (__props.data.type === 'combination')
          ? (_openBlock(), _createElementBlock("div", _hoisted_20, [
              _hoisted_21,
              _createElementVNode("p", _hoisted_22, _toDisplayString(__props.data.name), 1)
            ]))
          : (_openBlock(), _createElementBlock("div", _hoisted_23, [
              _createElementVNode("img", {
                referrerPolicy: "no-referrer",
                src: _unref(apiShopIcon)[__props.data.thirdPlatformType],
                style: {"width":"16px","margin-right":"6px"},
                class: "logo"
              }, null, 8, _hoisted_24),
              _createElementVNode("span", _hoisted_25, _toDisplayString(__props.data.name), 1)
            ])),
    _createElementVNode("p", _hoisted_26, [
      (__props.data.price)
        ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
            _createTextVNode(_toDisplayString(__props.data.price || 0) + _toDisplayString(_unref(showCurrentUnit)(__props.data.goodsCountry === _unref(COUNTRY).KR)) + " (" + _toDisplayString(__props.data.PriceJpy || 0) + _toDisplayString(_unref(t)('円')) + ") ", 1)
          ], 64))
        : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
            _createTextVNode(_toDisplayString(__props.data.PriceJpy || 0) + _toDisplayString(_unref(t)('円')), 1)
          ], 64))
    ]),
    (__props.data.isStock)
      ? (_openBlock(), _createElementBlock("div", _hoisted_27, _toDisplayString(_unref(t)('可用库存')) + ":" + _toDisplayString(__props.data.availableQuantity), 1))
      : _createCommentVNode("", true),
    _createElementVNode("div", {
      class: _normalizeClass(["select-btn", {disabled:__props.data.blackTag === 1}]),
      onClick: selectFn
    }, _toDisplayString(_unref(t)('选择2')), 3)
  ]))
}
}

})